import React, { Fragment, JSX } from "react";
import { Menu, Transition } from "@headlessui/react";
import { HiDotsVertical } from "react-icons/hi";
import classNames from "classnames";

// Adapted from https://tailwindui.com/components/application-ui/elements/dropdowns
export const DotDotMenu = ({
  items,
}: {
  items: Array<{ key: string; render: () => JSX.Element }>;
}): JSX.Element => {
  return (
    <Menu as="div" className="relative inline-block text-left">
      {({ open }) => (
        <>
          <div>
            <Menu.Button className="flex items-center text-gray-500 rounded-full hover:text-gray-600 focus:outline-none focus:ring-1 focus:ring-offset-gray-100 focus:ring-gray-600">
              <HiDotsVertical className="w-5 h-5" />
            </Menu.Button>
          </div>

          <Transition
            show={open}
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items
              static
              className="absolute right-0 z-10 mt-2 origin-top-right bg-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
            >
              <div className="py-1">
                {items.map((item) => {
                  const Render = item.render;
                  return (
                    <Menu.Item key={item.key}>
                      {({ active }) => (
                        <div
                          className={classNames(
                            active
                              ? "bg-gray-100 text-gray-900"
                              : "text-gray-700",
                            "block px-4 py-2 text-sm hover:bg-gray-100 hover:text-gray-900",
                          )}
                        >
                          <Render />
                        </div>
                      )}
                    </Menu.Item>
                  );
                })}
              </div>
            </Menu.Items>
          </Transition>
        </>
      )}
    </Menu>
  );
};
